import { SalesChannel } from '../dto/model';
import {strings} from '../lang';

const getSalesChannelLabel = (salesChannel: SalesChannel | null) => {
  if (!salesChannel) {
    return 'PV Digital Sales';
  }

  switch (salesChannel) {
    case SalesChannel.CrmSales:
      return 'CRM Special Channel';
    case SalesChannel.FieldSales:
      return 'PV Field Sales';
    case SalesChannel.Revision:
      return 'PV Revision';
    case SalesChannel.LeadQueue:
      return 'Lead Queue';
    case SalesChannel.SpecialSalesChannel1:
      return 'Special Sales Channel 1';
    case SalesChannel.SpecialSalesChannel2:
      return 'Special Sales Channel 2';
    case SalesChannel.SpecialSalesChannel3:
      return 'Special Sales Channel 3';
    case SalesChannel.SpecialSalesChannel4:
      return 'Special Sales Channel 4';
    case SalesChannel.SpecialSalesChannel5:
      return 'Special Sales Channel 5';
    default:
      return 'PV Digital Sales';
  }
};

const calculateHowLongCustomerHasBeenAdded = (creationDate: Date | null) => {
  const createdDate = creationDate ? new Date(creationDate) : null;
  if (createdDate) {
    const today = new Date();

    const timeDiff = Math.abs(today.getTime() - createdDate.getTime());
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (daysDiff <= 1) {
      if (today.getDate() === createdDate.getDate()) {
        return strings.signedupPeriod.today;
      }
      return strings.signedupPeriod.yesterday;
    } else if (daysDiff <= 2) {
      return strings.signedupPeriod.yesterday;
    } else if (daysDiff <= 7) {
      return strings.signedupPeriod.daysAgo.replace('{0}', daysDiff.toString());
    } else if (daysDiff <= 30) {
      return strings.signedupPeriod.weeksAgo.replace('{0}', Math.floor(daysDiff / 7).toString());
    } else if (daysDiff <= 90) {
      return strings.signedupPeriod.monthsAgo.replace('{0}', Math.floor(daysDiff / 30).toString());
    } else {
      return strings.signedupPeriod.moreThan3MonthsAgo;
    }
  }
};

export { calculateHowLongCustomerHasBeenAdded, getSalesChannelLabel };
